// ~/constants/sidebar.ts
import { faCog, faHeadset, faBox } from "@fortawesome/pro-light-svg-icons";
import { faPalette } from "@fortawesome/pro-solid-svg-icons";
import { paths } from "~/router/paths";
import { INavItem } from "~/types/routing";
import { DISABLE_PAYMENTS } from "~/helpers/plans";
import { triggerShowConnectStoreModal } from "~/helpers/customEvents";
import packageIcon from "~/assets/svg/package.svg";
import packageActiveIcon from "~/assets/svg/package-active.svg";
import ShoppingCartInactiveIcon from "~/assets/svg/ShoppingCart-Inactive.svg";
import ShoppingCartActiveIcon from "~/assets/svg/ShoppingCart.svg";
import ProductLibraryInactiveIcon from "~/assets/svg/product_library.svg";
import ProductLibraryActiveIcon from "~/assets/svg/active_product_library.svg";
import StoreLibraryInactiveIcon from "~/assets/svg/store_library/store_library.svg";
import StoreLibraryActiveIcon from "~/assets/svg/store_library/active_store_library.svg";
import SalesInsightsInactiveIcon from "~/assets/svg/new-trending-up.svg";
import SalesInsightsActiveIcon from "~/assets/svg/active-trending-up.svg";
import aliexpressInactiveIcon from "~/assets/svg/aliexpress.svg";
import aliexpressActiveIcon from "~/assets/svg/aliexpress-active.svg";
import themeDetectorInactiveIcon from "~/assets/svg/theme-detector.svg";
import themeDetectorActiveIcon from "~/assets/svg/Active-ShoppingCart.svg";
import settingsInactiveIcon from "~/assets/svg/settings.svg";
import settingsActiveIcon from "~/assets/svg/settings-active.svg";
import homeInactiveIcon from "~/assets/svg/home.svg";
import homeActiveIcon from "~/assets/svg/home-active.svg";
import HelpSVG from "~/assets/svg/help.svg";
import connectStoreIcon from "~/assets/svg/connect.svg";

export const HELP_CENTER_URL =
  "https://www.notion.so/Dropshiptool-1d80c13273a280d29ba6efacb0a5cd9b";
import adSpyInactiveIcon from "~/assets/svg/bullhorn-regular-inactive.svg";
import adSpyActiveIcon from "~/assets/svg/bullhorn-regular-active.svg";

export const navItems: INavItem[] = [
  {
    sectionLabel: "nav.title_dashboard",
    namePath: "nav.title_dashboard",
    path: paths.app.home,
    iconImage: homeInactiveIcon,
    activeIconImage: homeActiveIcon,
  },
  {
    namePath: "nav.aliexpress_products",
    path: paths.app.aliexpressProducts,
    iconImage: aliexpressInactiveIcon,
    activeIconImage: aliexpressActiveIcon,
  },
  {
    sectionLabel: "nav.title_product",
    namePath: "nav.product_database",
    path: paths.app.productLibrary,
    iconImage: ProductLibraryInactiveIcon,
    activeIconImage: ProductLibraryActiveIcon,
  },
  {
    namePath: "nav.store_library",
    path: paths.app.storeLibrary,
    iconImage: StoreLibraryInactiveIcon,
    activeIconImage: StoreLibraryActiveIcon,
  },
  // {
  //   // Product Portfolio is now a parent item
  //   namePath: "nav.product_portfolio",
  //   icon: faBox,
  //   children: [
  //     {
  //       namePath: "nav.my_portfolio",
  //       path: paths.productPortfolio.myPortfolioRoot,
  //     },
  //     {
  //       namePath: "nav.collections",
  //       path: paths.productPortfolio.collectionsRoot,
  //     },
  //   ],
  // },
  {
    namePath: "nav.ad_spy_tool",
    path: paths.app.adSpyTool,
    iconImage: adSpyInactiveIcon,
    activeIconImage: adSpyActiveIcon,
  },
  {
    namePath: "nav.product_drops",
    iconImage: packageIcon,
    activeIconImage: packageActiveIcon,
    children: [
      {
        namePath: "nav.my_drops",
        path: paths.productDrops.myDropsRoot,
      },
      {
        namePath: "nav.saved_lists",
        path: paths.productDrops.savedListsRoot,
      },
    ],
  },
  {
    namePath: "nav.sales_insights",
    path: paths.app.myTrackings,
    iconImage: SalesInsightsInactiveIcon,
    activeIconImage: SalesInsightsActiveIcon,
    navExact: false,
  },
  {
    sectionLabel: "nav.title_identify",
    namePath: "nav.competitor_analysis",
    path: paths.app.competitorAnalysis,
    iconImage: ShoppingCartInactiveIcon,
    activeIconImage: ShoppingCartActiveIcon,
  },
  {
    namePath: "nav.theme_detector",
    path: paths.app.themeDetector,
    iconImage: themeDetectorInactiveIcon,
    activeIconImage: themeDetectorActiveIcon,
  },
  {
    namePath: "settings.title",
    path: DISABLE_PAYMENTS ? paths.settings.account : paths.settings.plans,
    iconImage: settingsInactiveIcon,
    activeIconImage: settingsActiveIcon,
  },
  {
    namePath: "nav.connect-store",
    path: "/connect-store",
    iconImage: connectStoreIcon,
    activeIconImage: connectStoreIcon,
    onClick: () => triggerShowConnectStoreModal(),
  },
  {
    namePath: "nav.help_center",
    path: HELP_CENTER_URL,
    openInNewTab: true,
    icon: HelpSVG,
    iconImage: HelpSVG,
  },
];
